import {ACTION_CODE} from './_actionCode';
import {PaymentMethodService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'CREATE_PAYMENT_METHOD';

export async function createPaymentMethod(userData: Record<string, any>, paymentMethod: Record<string, any>) {
    try {
        LoggerService.logInfo('Action - createPaymentMethod - Start');

        const createPaymentMethodResult = await PaymentMethodService.createPaymentMethod(userData, paymentMethod);

        LoggerService.logInfo('Action - createPaymentMethod - End - Success');

        return ResultModel.newSuccessResult(createPaymentMethodResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - createPaymentMethod - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la création d‘une méthode de paiement.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
